import { AccordionSummaryProps as MuiAccordionSummaryProps } from '@mui/material/AccordionSummary'

export type AccordionSummaryProps = MuiAccordionSummaryProps
